module.exports = __webpack_public_path__ + "img/maccabi-haifa.39fa49ef.png";